const styles = theme => ({
  main: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.primary.dark,
    flex: 'auto',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  }
})

export default styles
